import { render, staticRenderFns } from "./ProductStockValueTransactionType.vue?vue&type=template&id=239c12ba&"
import script from "./ProductStockValueTransactionType.vue?vue&type=script&lang=js&"
export * from "./ProductStockValueTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports